export default __webpack_public_path__ + "MJt_reports.html";